<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <div class="row m-0 formborder">
    <div class="col-md-6 p-1">
      <form action="" class="search-text">
        <div class="bg-light rounded rounded-pill shadow-sm">
          <div class="input-group">
            <input
              type="text"
              id="FilterInputSearch"
              (keyup)="applyFilter($event.target.value)"
              name="FilterInputSearch"
              placeholder="What're you searching for?"
              class="form-control border-0 bg-light"
            />
            <div class="input-group-append">
              <button
                id="button-addon1"
                type="submit"
                class="btn btn-link text-primary"
              >
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="col-md-6 p-1 text-right">
      <button
        class="mt-3 btn font-size-12 button-btn"
        (click)="onOpenSubAreaModal()"
      >
        Add New Sub Area
      </button>
    </div>
  </div>

  <div class="table-responsive mt-3">
    <mat-table [dataSource]="dataCustomerSource">
      <ng-container matColumnDef="Number">
        <mat-header-cell class="grid-header" *matHeaderCellDef>
          #
        </mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
          {{ i + 1 }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="SubArea">
        <mat-header-cell class="grid-header" *matHeaderCellDef>
          SubArea
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.Sub_Area_Name }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Area">
        <mat-header-cell class="grid-header" *matHeaderCellDef>
          Area
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.Area_Name }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Branch">
        <mat-header-cell class="grid-header" *matHeaderCellDef>
          Branch
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.Branch_Name }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Action">
        <mat-header-cell class="grid-header j-c-center" *matHeaderCellDef>
          Action
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell j-c-center">
          <i
            class="fas fa-lg fa-edit margin-right-4xs cursor-style"
            aria-label="true"
            (click)="editCollectionSubArea(row)"
          ></i>
          <i
            class="fa fa-trash style-delete"
            (click)="removeSubArea(row)"
            aria-label="true"
          ></i>
        </mat-cell>
      </ng-container>
      <mat-header-row
        *matHeaderRowDef="displayedCustomerColumns"
      ></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedCustomerColumns"
      ></mat-row>
    </mat-table>
  </div>
  <div class="row m-0 mt-2">
    <div class="col-md-12 d-flex justify-content-end p-0">
      <button
        class="btn font-size-12 button-btn"
        (click)="exportexcelNew()"
      >
        <i
          class="fa fa-file-export mr-1"
          style="font-size: 14px; cursor: pointer"
        ></i>
        Export
      </button>
    </div>
  </div>
</div>

<div
  class="modal fade in"
  id="AddEditSubAreaModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <form #f="ngForm" (ngSubmit)="onSaveSubArealData()" novalidate>
    <div class="modal-dialog" role="document">
      <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
        <div cdkDragHandle class="modal-header" style="padding: 10px">
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
            {{ ButtonName }} Sub Area
          </h6>
          <button
            type="button"
            (click)="OnClose()"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">
              <i class="far text-black fa-times-circle"></i>
            </span>
          </button>
        </div>
        <div class="modal-body formborder m-3">
          <div class="row m-0 font-size-12 align-items-center">
            <div class="col-md-4 p-1">
              <span class="required-lable">Sub Area Name</span>
            </div>
            <div class="col-md-8 p-1">
              <input
                required
                type="text"
                #refUnderSubArea="ngModel"
                [ngClass]="{
                  'is-invalid': f.submitted && refUnderSubArea.invalid,
                  'alert-warning':
                    refUnderSubArea.invalid &&
                    (refUnderSubArea.dirty ||
                      refUnderSubArea.touched ||
                      refUnderSubArea.untouched)
                }"
                [(ngModel)]="UnderSubArea"
                placeholder="Sub Area Name"
                name="UnderSubArea"
                id="UnderSubArea"
                class="form-control input-text-css"
              />
            </div>
          </div>
          <div class="row m-0 font-size-12 align-items-center">
            <div class="col-md-4 p-1">
              <span class="required-lable">Under Area</span>
            </div>
            <div class="col-md-8 p-1">
              <select
                name="UnderArea"
                id="UnderArea"
                (change)="changeArea($event)"
                #refUnderArea="ngModel"
                [ngClass]="{
                  'is-invalid': f.submitted && refUnderArea.invalid,
                  'alert-warning':
                    refUnderArea.invalid &&
                    (refUnderArea.dirty ||
                      refUnderArea.touched ||
                      refUnderArea.untouched)
                }"
                [(ngModel)]="UnderArea"
                class="form-control input-text-css"
                required
              >
                <option value="">Select Area</option>
                <option *ngFor="let area of AreaList" [value]="area.Int_Id">
                  {{ area.Area_Name }}
                </option>
              </select>
            </div>
          </div>
          <div class="row m-0 font-size-12 align-items-center">
            <div class="col-md-4 p-1">
              <span class="required-lable">Under Branch</span>
            </div>
            <div class="col-md-8 p-1">
              <select
                name="SelectBranch"
                id="SelectBranch"
                #refSelectBranch="ngModel"
                [ngClass]="{
                  'is-invalid': f.submitted && refSelectBranch.invalid,
                  'alert-warning':
                    refSelectBranch.invalid &&
                    (refSelectBranch.dirty ||
                      refSelectBranch.touched ||
                      refSelectBranch.untouched)
                }"
                [(ngModel)]="SelectBranch"
                class="form-control input-text-css"
                required
              >
                <option value="">Select Branch</option>
                <option
                  *ngFor="let branch of BranchesList"
                  [value]="branch.BranchId"
                >
                  {{ branch.Branch_Name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            (click)="OnClose()"
            class="mt-3 btn font-size-12 button-btn"
            data-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            (click)="onSaveSubArealData()"
            class="mt-3 btn font-size-12 button-btn"
            [class.spinner]="loading"
            [disabled]="!f.form.valid"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<table
  id="sub-area-table"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
  <tr>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">#</th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Sub Area
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Area
    </th>
    <th style="background: var(--theme-primary) !important; border: 1px solid white">
      Branch
    </th>
  </tr>

  <tr *ngFor="let x of JsonData; let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ x.Sub_Area_Name }}</td>
    <td>{{ x.Area_Name }}</td>
    <td>{{ x.Branch_Name }}</td>
  </tr>
</table>
